import { W9FormData } from '@bybeam/platform-types';
import TextInput from '@platform-ui-common/components/TextInput/index.js';
import { fieldUpdate } from '@platform-ui-common/hooks/useForm/index.js';
import { FormProps } from '@platform-ui-common/types/index.js';
import { Mask } from '@platform-ui-common/utilities/format.js';

const EINInput = ({ formData, dispatch, errors }: FormProps<W9FormData>) => {
  return (
    <TextInput
      id="ein"
      required
      label="Enter employer identification number"
      value={formData.ein ?? ''}
      onChange={(value: string): void => dispatch(fieldUpdate('ein', value))}
      error={errors.ein as string}
      mask={Mask.EIN}
    />
  );
};

export default EINInput;
